import { createActionSet } from "../helpers/Helpers";

// SAMPLE ACTION SET
export const SAMPLE = createActionSet("SAMPLE");

// NEWS
export const NEWS = createActionSet("NEWS");
export const NEWS_DETAIL = createActionSet("NEWS_DETAIL");

// PRESS RELEASE
export const PRESS = createActionSet("PRESS");
export const PRESS_DETAIL = createActionSet("PRESS_DETAIL");

// CONTACT
export const CONTACT = createActionSet("CONTACT");

//TEAMMEMBER ACTION SET
export const TEAMMEMBER = createActionSet("TEAMMEMBER");
export const DIRECTORS = createActionSet("DIRECTORS");
export const STATION_CHIEF = createActionSet("STATION_CHIEF");

//PUBLICATION ACTION SET
export const PUBLICATION = createActionSet("PUBLICATION");
export const PUBLICATION_DETAIL = createActionSet("PUBLICATION_DETAIL");

//BOOKS ACTION SET
export const BOOKS_LIST = createActionSet("BOOKS_LIST");
export const BOOKS_DETAIL = createActionSet("BOOKS_DETAIL");

//BOOKS ACTION SET
export const BOOKLET_LIST = createActionSet("BOOKLET_LIST");
export const BOOKLET_DETAIL = createActionSet("BOOKLET_DETAIL");

//BOOKS ACTION SET
export const ANNUAL_REPORT_LIST = createActionSet("ANNUAL_REPORT_LIST");
export const ANNUAL_REPORT_DETAIL = createActionSet("ANNUAL_REPORT_DETAIL");

//NEWSLETTER ACTION SET
export const NEWSLETTER = createActionSet("NEWSLETTER");

//RESEARCH ACTION SET
export const RESEARCH = createActionSet("RESEARCH");
export const GET_RESEARCH_CATEGORY = createActionSet("GET_RESEARCH_CATEGORY");

//STUDY ACTION SET
export const STUDY_DETAIL = createActionSet("STUDY_DETAIL");
//COLLABORATOR ACTION SET
export const COLLABORATOR = createActionSet("COLLABORATOR");

//VACANCY ACTION SET
export const VACANCY = createActionSet("VACANCY");

//EVENT ACTION SET
export const EVENT = createActionSet("EVENT");
export const EVENT_DETAIL = createActionSet("EVENT_DETAIL");

//RESEARCH ARTICLES
export const RESEARCH_ARTICLE = createActionSet("RESEARCH_ARTICLE");

//GALLERY
export const PHOTO_GALLERY = createActionSet("PHOTO_GALLERY");
export const VIDEO_GALLERY = createActionSet("VIDEO_GALLERY");
//FARMER_CORNER
export const FARMER_CORNER = createActionSet("FARMER_CORNER");

// CURRENT_RESEARCH
export const CURRENT_RESEARCH = createActionSet("CURRENT_RESEARCH");
